export enum AppRoute {
  Home = '/kids/[kid]',
  HomeMath = '/kids/[kid]/math',
  HomeEla = '/kids/[kid]/ela',
  PadMath = '/kids/[kid]/math/pad',
  PadEla = '/kids/[kid]/ela/pad',
  PricingMath = '/kids/[kid]/math/pricing',
  PricingEla = '/kids/[kid]/ela/pricing',
  AssessmentMath = '/kids/[kid]/math/assessments',
  AssessmentEla = '/kids/[kid]/ela/assessments',
  AssessmentResultsMath = '/kids/[kid]/math/assessments/[assessment]',
  AssessmentResultsEla = '/kids/[kid]/ela/assessments/[assessment]',
  AssessmentCatchUpResultsMath = '/kids/[kid]/math/assessments/[assessment]/catch-up',
  AssessmentCatchUpResultsEla = '/kids/[kid]/ela/assessments/[assessment]/catch-up',
  SummarizeMath = '/kids/[kid]/math/summarize/[summarize]',
  SummarizeEla = '/kids/[kid]/ela/summarize/[summarize]',
  Files = '/kids/[kid]/math/files',
  FilesEla = '/kids/[kid]/ela/files',
  Lessons = '/kids/[kid]/math/lessons',
  LessonsEla = '/kids/[kid]/ela/lessons',
  LearningProgress = '/kids/[kid]/math/learning-progress',
  LearningProgressEla = '/kids/[kid]/ela/learning-progress',
  LearningProgressGoals = '/kids/[kid]/math/learning-progress/goals',
  LearningProgressGoalsEla = '/kids/[kid]/ela/learning-progress/goals',
  LearningPlan = '/kids/[kid]/math/learning-progress/learning-plan',
  LearningPlanEla = '/kids/[kid]/ela/learning-progress/learning-plan',
  LearningPlanUnits = '/kids/[kid]/math/learning-progress/learning-plan/units',
  LearningPlanUnitsEla = '/kids/[kid]/ela/learning-progress/learning-plan/units',
  LearningPlanUnit = '/kids/[kid]/math/learning-progress/learning-plan/[unit]',
  LearningPlanUnitEla = '/kids/[kid]/ela/learning-progress/learning-plan/[unit]',
  LessonRoom = '/kids/[kid]/math/classroom/[booking]',
  LessonRoomEla = '/kids/[kid]/ela/classroom/[booking]',
  Schedule = '/kids/[kid]/math/schedule',
  ScheduleEla = '/kids/[kid]/ela/schedule',
  SkillReport = '/kids/[kid]/math/learning-progress/skill-report',
  SkillReportEla = '/kids/[kid]/ela/learning-progress/skill-report',
  ProgressReports = '/kids/[kid]/math/learning-progress/reports',
  ProgressReportsEla = '/kids/[kid]/ela/learning-progress/reports',
  MasteryMaps = '/kids/[kid]/math/learning-progress/mastery-map',
  MasteryMapsEla = '/kids/[kid]/ela/learning-progress/mastery-map',
  LearningProgressAssessments = '/kids/[kid]/math/learning-progress/assessments',
  LearningProgressAssessmentsEla = '/kids/[kid]/ela/learning-progress/assessments',
  LearningProgressAssessment = '/kids/[kid]/math/learning-progress/assessments/[assessment]',
  LearningProgressAssessmentEla = '/kids/[kid]/ela/learning-progress/assessments/[assessment]',
  ProgressReport = '/kids/[kid]/math/learning-progress/reports/[report]',
  ProgressReportEla = '/kids/[kid]/ela/learning-progress/reports/[report]',
  Payments = '/payments',
  PaymentsHistory = '/payments/history',
  PaymentsMethods = '/payments/methods',
  PaymentsSubscriptions = '/payments/subscriptions',
  HelpCenter = '/helpcenter',
  Login = '/login',
  Profile = '/profile',
  Order = '/orders/[order]',
  Checkout = '/orders/[order]/checkout',
  Upsell = '/orders/[order]/upsell',
  UpsellBooking = '/orders/[order]/upsell/booking',
  UpsellPlan = '/orders/[order]/upsell/plan',
  Feedback = '/feedbacks/[booking_id]',
  FeedbackThankYou = '/feedback/thank-you',
  Referral = '/referral',
}
